import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import Header from './Header';
import TableOfContents, { ContentsItem } from './TableOfContents';

interface BlogPostLayoutProps {
  title: string;
  children: React.ReactNode;
  contents?: ContentsItem[];
}

function BlogPostLayout({ title, children, contents }: BlogPostLayoutProps) {
  return (
    <div className="page">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Header />

      <main id="main-content">
        <article className={`content-section blog-post-page ${contents ? 'blog-post-page--with-contents' : ''}`}>
          <div className="blog-post-container">
            <p className="blog-post-back">
              <Link to="/help-and-advice">← Back to Help and Advice</Link>
            </p>
            <h1 className="blog-post-title">{title}</h1>
            {contents ? (
              <div className="blog-post-body">
                <TableOfContents items={contents} />
                <div className="blog-post-content">
                  {children}
                </div>
              </div>
            ) : (
              <div className="blog-post-content">
                {children}
              </div>
            )}
          </div>
        </article>
      </main>

      <footer className="footer">
        <section className="footer__enquiry">
          <div className="footer__enquiry-container">
            <Link to="/contact-us" className="footer__enquiry-link">
              Enquire about Graham Care <span className="footer__arrow">▶</span>
            </Link>
          </div>
        </section>
        <div className="footer__container">
          <section className="contact-section">
            <div className="contact-section__content">
              <p>Graham Care Ltd, KT15 1HH</p>
              <p>Copyright © Graham Care Ltd</p>
            </div>
          </section>
        </div>
      </footer>
    </div>
  );
}

export default BlogPostLayout;
